import { Button, ButtonWithPopOut } from "@newsela/angelou";
import PropTypes from "prop-types";

import InfoIcon from "@/icons/InfoIcon";
import {
  buttonCss,
  iconCss,
  popOutCss,
  popOutContentsCss,
} from "./ContentWarning.style";

const propTypes = {
  contentWarning: PropTypes.string,
};

const ContentWarning = ({ contentWarning }) => {
  const defaultMessage =
    "This material contains sensitive content that may be upsetting for some readers.";

  const buttonContents = () => {
    return (
      <>
        Sensitive Content
        <InfoIcon css={iconCss} />
      </>
    );
  };

  const popOutContents = () => {
    return (
      <div css={popOutContentsCss}>
        {!contentWarning ? defaultMessage : contentWarning}
      </div>
    );
  };

  return (
    <ButtonWithPopOut
      __cssFor={{
        Button: { root: buttonCss },
        PopOut: { root: popOutCss },
      }}
      ariaProps={{ "aria-label": "Sensitive Content Warning" }}
      buttonContents={buttonContents()}
      closeOnBlur
      /* AUTOGENERATED TODO: update angelou to new flavor.
        see https://github.com/newsela/angelou/blob/main/src/components/Button/README.md#MIGRATION
        for migration guide. */
      legacy_flavor={Button.legacy_flavor.solid}
      horizontalOffset="-32px"
      id="sensitive-content-warning"
      popOutContents={popOutContents()}
      legacy_size={Button.legacy_size.medium}
    />
  );
};

ContentWarning.propTypes = propTypes;

export default ContentWarning;
